import React, { useLayoutEffect, useContext } from "react";
import ApiRole from "../../../app/api/admin/role/ApiRole";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import ListHeaderItem from "../../modules/list/__header-item";
import ListBodyItem from "../../modules/list/__body-item";
import ButtonLinkShow from "../../components/button-link/__show";
import ButtonLinkAdd from "../../components/button-link/__add";

// Список ролей панели.
export default function RolesIndex({ ...other }) {
    return <Page {...other}>
        <RolesIndexContent/>
    </Page>;
}

function RolesIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    useLayoutEffect(() => {
        contextContent.setTitle('Роли');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const header = [
        <ListHeaderItem key="id" name="id" isSort={false}>ID</ListHeaderItem>,
        <ListHeaderItem key="slug" name="slug" isSort={false}>Слаг</ListHeaderItem>,
        <ListHeaderItem key="label" name="label" isSort={false}>Название</ListHeaderItem>,
        <ListHeaderItem key="create" name="create" isSort={false}>
            {contextContent.checkPermission('create')
                ? <ButtonLinkAdd className="button-link_white" title="Создать" href={contextPage.routes.create.url()}/> : null}
        </ListHeaderItem>,
    ];

    const renderRow = (row) => [
        <ListBodyItem key="id">{row.id}</ListBodyItem>,
        <ListBodyItem key="slug">{row.slug}</ListBodyItem>,
        <ListBodyItem key="label">{row.label || '—'}</ListBodyItem>,
        <ListBodyItem key="show">
            {contextContent.checkPermission('show')
                ? <ButtonLinkShow className="button-link_blue" title="Просмотр" href={contextPage.routes.show.url({ id: row.id })}/> : null}
        </ListBodyItem>,
    ];

    return <List
        header={header}
        ApiModel={ApiRole}
        renderRow={renderRow}
        defaultSortKey="slug"
        defaultSortIsAsc={true}
    />;
}
